<template>
  <section class="success">
    <popup-base
      v-show="wantToMakeOffer"
      class="popo md:pt-10 md:pb-4 w-full"
      @clickOnBackground="logState"
    >
      <div class="cardinal mr-auto ml-auto p-5">
        <div
          class="success-container h-full pt-6"
        >
          <div class="text-left flex pl-6 pr-6">
            <div
              class="text-c24 font-c7 w-4/5"
            >
              Prix
            </div>
            <div class="w-1/5 flex justify-end">
              <icon
                :data="icons.fermer"
                height="30"
                width="30"
                class="cursor-pointer"
                original
                @click="fermer"
              />
            </div>
          </div>

          <div class="text-c18 font-c4 mt-6 bg-white p-6 pb-12">
            <div class="text-left text-c12">
              Intitulé
            </div>
            <inputo
              class="mt-2"
              placeholder="Montange monture client"
              @info="retourNom"
            />

            <div class="text-left text-c12 mt-8">
              Type de prix
            </div>

            <div class="flex">
              <div
                  v-for="(item, index) in allInfo"
                  :key="index"
                  class="w-1/2 pl-1 pr-1 mb-3 mt-2"
              >
                <radios
                    class="w-full"
                    :index="item"
                    :position="position"
                    @radioStat="retourPrix"
                    v-if="index < 5"
                />
              </div>
            </div>

            <div v-if="position === 'Prix promotionnel'">
              <div class="text-left text-c12 mt-6">
                Date de début
              </div>

              <div class="mt-2">
                <datePicker @info="retourStartDate"/>
              </div>

              <div class="text-left text-c12 mt-6">
                Date de fin
              </div>

              <div class="mt-2">
                <datePicker @info="retourEndDate"/>
              </div>
            </div>

            <div
              v-if="error !== null"
              class="mt-6 text-red text-c14"
            >
              {{ error }}
            </div>
          </div>

          <div class="flex">
            <div class="w-full">
              <buton
                label="Enregistrer"
                radius="0px"
                height="55px"
                :charge="charge"
                @oga="continuer"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popupfat'
import buton from '../helper/add/button'
import ic_agence from '../../assets/icons/agenceGray.svg'
import fermer from '../../assets/icons/fermer.svg'
import inputo from '../helper/form/input'
import radios from '../helper/form/radioAndLabel'
import datePicker from '../helper/form/datePicker'
import http from "../../plugins/https"
import apiroutes from "../../router/api-routes"

export default {
  name: 'Success',
  components: { PopupBase, buton, inputo, radios, datePicker },

  props: {
    activation: {
      type: Boolean,
      default: false
    },
    donne: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      donnes: null,
      wantToMakeOffer: false,
      icons: {
        ic_agence,
        fermer
      },
      nom: '',
      error: null,
      charge: false,
      allInfo: ['Prix fixe', 'Prix promotionnel'],
      position: 0,
      startDate: null,
      endDate: null
    }
  },

  created() {
    this.wantToMakeOffer = this.activation
  },

  methods: {
    fermer () {
      this.$emit('oga', false)
    },

    continuer (answer) {
      this.charge = true
      this.error = null
      if (this.nom.length > 0 && this.position !== 0) {
        let body = {
          label: this.nom,
          isForLife: true
        }

        if (this.position === 'Prix promotionnel'){
          body.isForLife = false
          if (this.startDate !== null && this.endDate !== null){
            body.startDate = this.startDate
            body.endDate = this.endDate
            this.save(body)
          } else {
            this.charge = false
            this.error = 'Veuillez définir une date de début et de fin pour la promotion'
          }
        } else {
          this.save(body)
        }
      } else {
        this.charge = false
        this.error = 'Veuillez remplir les champs pour continuer'
      }
    },

    save (body) {
      console.log(body)
      http.post(apiroutes.baseURL + apiroutes.createPrice, body)
          .then(response => {
            console.log(response)
            this.$emit('oga', true)
            this.charge = false
          })
          .catch(error => {
            this.charge = false
            console.log(error)
            this.error = "Problème de connexion. Veuillez ressayer"
          })
    },

    retourStartDate (answer) {
      this.startDate = answer
    },

    retourEndDate (answer) {
      this.endDate = answer
    },

    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
    },


    retourNom (answer) {
      this.nom = answer
    },

    retourPrix (answer) {
      this.position = answer
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/styles/sass/mixin";
    .success {
      z-index: 999;
    }
    .cardinal {
      width: 42%;
    }

    .success-container {
      font-family: $font-default;
      width: 100%;
      background-color: #F5F5F5;
      height: auto;
      margin: auto;
      border-radius: 12px;
    }
    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
        height: 100vh;
      }
      .titre {
        font-size: 18px;
      }
      .bloc1 {
        width: 100%;
      }
      .bloc2 {
        width: 100%;
        font-size: 18px;
      }
      .button {
        width: 100%;
        font-size: 16px;
      }
      .cardinal {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) and (min-width: 770px){
      .cardinal{
        width: 65%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }

    @media screen and (max-width: 769px) and (min-width: 701px){
      .cardinal{
        width: 90%;
      }
      .titre{
        font-size: 18px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 19px;
      }
    }
    @media screen and (max-width: 320px){
      .cardinal{
        width: 100%;
      }
      .titre{
        font-size: 14px;
      }
      .button{
        width: 100%;
        height: 55px;
        font-size: 15px;
      }
    }
</style>
